<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="{ 'navbar-light': type === 'default' }"
  >
    <!-- Search form -->
    <!-- <fuzzy-search>
    </fuzzy-search> -->
    
    <!-- Navbar links -->
    <b-navbar-nav class=" align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div
          class="pr-3 sidenav-toggler"
          :class="{
            active: $sidebar.showSidebar,
            'sidenav-toggler-dark': type === 'default',
            'sidenav-toggler-light': type === 'light'
          }"
          @click="toggleSidebar"
        >
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, which we cant add -->
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      
      
    </b-navbar-nav>
    <b-navbar-nav class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
            <div class="mr-5">
              <el-popover
                placement="bottom-end"
                width="400"
                trigger="hover"
                :content="`${isProd ? 'BEWARE - Everything you update here is LIVE...' : 'RELAX - This is a test environment, go to town!'}`">
                <el-button slot="reference" :type="`${isProd ? 'warning' : 'info'}`" size="small">{{isProd ? 'PRODUCTION' : 'DEVELOPMENT'}}</el-button>
              </el-popover>
            </div>
            <b-media-body class="ml-2 d-none d-lg-block">
              <i class="fas fa fa-user" style="color: #333!important"></i>
            </b-media-body>
          </b-media>
        </a>

        <template>
          <!-- <b-dropdown-item :href="`/#/users/me`">
            <i class="fas fa-id-card"></i>
            <span>My profile</span>
          </b-dropdown-item> -->
          <!-- <div class="dropdown-divider"></div> -->
          <b-dropdown-item href="#" @click="logout">
            <i class="fas fa-sign-out"></i>
            <span>Logout</span>
          </b-dropdown-item>
        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { CollapseTransition } from 'vue2-transitions'
import { BaseNav, Modal } from '@/components'
import { Popover, Button } from 'element-ui';
import api from '@/api';

export default {
  components: {
    CollapseTransition,
    BaseNav,
    Modal,
    [Popover.name]: Popover,
    [Button.name]: Button
  },
  props: {
    type: {
      type: String,
      default: 'light',
      description: 'default (green) or light (gray)'
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    ...mapGetters(['auth/pass', 'user/profile', 'user/profileLoaded']),
    ...mapState({
      // avatar: (state) => state.user.profile.avatar,
      name: (state) => state.user.profile.name
    })
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: '',
      isProd: process.env.NODE_ENV == 'production'
    };
  },
  // created() {
  //   this.logout()
  // },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    async logout() {
      const loader = this.$loading.show();
      await api.auth.logout();
      loader.hide();
      window.location.reload();
}
  }
};
</script>
